export const WebviewURL = {
    root: "wv",
    login: "wv/login",
    contract_list: "wv/contracts/list",
    contract_add: "wv/contracts/add",
    contract_edit: "wv/contracts/edit",
    contract_detail: "wv/contracts",
    login_otp: "wv/login-with-otp"
}